<template>
    <CContainer>
        <CRow>
            <CCol col="12" sm="8" class="mx-auto px-0">
                <CCustomInput
                    name
                    vid="searchQuery"
                    v-if="$policy('store').create_any_or_group"
                    v-model="searchQuery"
                    :placeholder="$t('table.type_string')"
                />
            </CCol>
        </CRow>
        <CRow v-if="storesCount">
            <CCol col="12" sm="8" class="mx-auto" v-if="Object.keys(storesFiltered).length > 0">
                <CCard>
                    <CCardBody>
                        <CListGroup style="max-height:300px;overflow-y:scroll">
                            <CListGroupItem
                                v-for="(store, index) in storesFiltered"
                                :key="index"
                                :to="{ name: 'publishers.list', params: { store_id: store.id } }"
                            >
                                <span class="mfs-2 d-inline-block">{{ store.name }}</span>
                            </CListGroupItem>
                        </CListGroup>
                    </CCardBody>
                </CCard>
            </CCol>
            <CCol col="12" sm="8" class="mx-auto" v-else>
                <EmptyPage>
                    <template #content>{{ $t('multiselect.no_result') }}</template>
                </EmptyPage>
            </CCol>
        </CRow>
        <CRow v-else>
            <CCol col="12" sm="8" class="mx-auto">
                <EmptyPage>
                    <template #content>{{ $t('store.has_no_active_publisher') }}</template>
                </EmptyPage>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { filterObject } from '@/common/objects'
import { sorts } from './partials/fields'

export default {
    name: 'StoresList',

    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (vm.$policy('store').create) {
                vm.$router.push({name:'publishers.list'})
            }
            // Just stores with members
            vm.fetch({
                no_paginate: true,
                store_users: {
                    store: {}
                }
            })
        })
    },

    beforeRouteLeave(to, from, next) {
        if (to.name === 'publishers.list') {
            this.publisherSetParams({
                page: 1,
                per_page: 20,
                sorter: sorts[0].value,
            })
        }

        next()
    },

    data() {
        return {
            searchQuery: '',
        }
    },

    computed: {
        ...mapGetters({
            stores: 'store/stores',
            storesCount: 'store/storesCount',
        }),
        storesFiltered() {
            return filterObject(this.stores, (item) => item.name.startsWith(this.searchQuery)) || {}
        }
    },

    methods: {
        ...mapActions({
            fetch: 'store/fetch',
            publisherSetParams: 'publisher/setParams',
        }),
    },
}
</script>